import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-conferencia-ceremonia',
  templateUrl: './conferencia-ceremonia.component.html',
  styleUrls: ['./conferencia-ceremonia.component.scss']
})
export class ConferenciaCeremoniaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
